// extracted by mini-css-extract-plugin
module.exports = {"firstRowItem":"Header_firstRowItem__oeIXb","selection":"Header_selection__3T_YQ"};